@for (slide of slides; track slide; let i = $index) {
  <section
    class="home"
    [class.overley]="withBackground"
    [ngStyle]="{'background-image': 'url(' + slide.url + ')'}"
    [style.display]="i === activeIndex ? 'flex' : 'none'">
    <div class="home-content">
      <span>{{ slide.title | translate }}</span>
      <h2>{{ slide.subTitle | translate }}</h2>
      <p [innerHTML]="slide.description | translate"></p>
      <!--<div class="button">Explore</div>-->
    </div>
  </section>
}

<i class="fas fa-chevron-circle-right slider-right slider-icon" (click)="action('previous')"></i>
<i class="fas fa-chevron-circle-left slider-left slider-icon" (click)="action('next')"></i>
